export default "__VITE_ASSET__aLVp$pf1__"